
import { Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';


const TIME_FORMAT='YYYY-MM-DD HH:mm:ss';
@Component({
    selector: 'app-human-time',
    templateUrl: './human-time.directive.html',
    
})
export class HumanTimeComponent {
    @Input() moment: any;
    humanTime: string= '';
    verboseTime: string='';

    constructor() {}

    ngOnInit() {
        this.humanTime = this.moment.fromNow();
        this.verboseTime = this.moment.format(TIME_FORMAT);
    }

    handleClick(){
        this.humanTime = this.moment.fromNow();
        this.verboseTime = this.moment.format(TIME_FORMAT);
    }
}
